import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { COLORS } from "../constants/constants"

const NotifRadio = ({ value, checked, onChange, ...props }) => {
  return (
    <Box as="label">
      <input
        type="radio"
        id={value}
        name={value}
        autoComplete={value}
        value={value}
        checked={checked}
        onChange={onChange}
        style={{ display: "none" }}
        {...props}
      />
      <Box
        minWidth={"60px"}
        py={"6px"}
        borderRadius={"8px"}
        bg={checked ? COLORS.white : COLORS.grey}
        color={checked ? COLORS.red : COLORS.secondary}
        fontWeight={600}
        textAlign="center"
        cursor="pointer"
        boxShadow={checked ? "0px 2px 5px rgba(0, 0, 0, 0.1)" : "none"}
      >
        <Text fontSize="14px" fontWeight={600} userSelect="none">
          {value}
        </Text>
      </Box>
    </Box>
  )
}

export default NotifRadio
